import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import { Box, Button, Typography } from "@material-ui/core";
import FruProOTPInput from "@components/OTPInput/OTPInput";
import { OTP_EXPIRED_TIME } from "../../../constants";
import SubmitButton from "../../submit-button/SubmitButton";
import { SectionContainer } from "../../styled/StyledComponents";
import { useSelector } from "react-redux";
import { AmptitudeEvents } from "@services/amptitude_events";
import { SMS_CODE_ENTERED_EVENT } from "@services/amptitude_contants";

const useStyles = makeStyles((theme) => ({
  descText: {
    color: theme.palette.primary.primaryB,
    fontSize: 16,
    fontWeight: "500",
    color: "#000000",
    marginTop: "20px",
  },
  otpInputContainer: {
    maxWidth: "100%",
    margin: "auto",
    marginBottom: 16,
  },
  resendText: {
    color: theme.palette.primary.primaryB,
    "& .resend": {
      cursor: "pointer",
    },
  },
  footerButton: {
    marginTop: 88,
  },
  root: {
    width: 480,
    height: "auto",
  },

  resendButton: {
    padding: "20px",
    display: "flex",
    width: "100%",
    marginTop: "24px",
    borderRadius: "20px",
    opacity: 1,
    pointerEvents: "auto",
    textAlign: "center",
  },

  resenSecondButton: {
    padding: "20px",
    display: "flex",
    width: "100%",
    marginTop: "24px",
    borderRadius: "20px",
    opacity: 0.6,
    pointerEvents: "none",
  },

  titleHeader: {
    color: "#e77128",
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "24px",
  },

  inputArea: {
    height: "59px",
  },

  counterResend: {
    display: "flex",
    alignItems: "center",
    margin: "auto",
  },
}));

export default function OTPVertification({ onResendOTP, onSubmit, isLoading }) {
  const classes = useStyles();

  const otpRef = useRef(null);
  const [OTP, setOTP] = useState();
  const [second, setSecond] = useState(OTP_EXPIRED_TIME);
  const [shouldCount, setShouldCount] = useState(true);
  const secondRef = useRef();
  const [buttonActive, setButtonActive] = useState(false);
  secondRef.current = second;

  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    let interval;
    if (shouldCount) {
      interval = setInterval(() => {
        setSecond((second) => second - 1);
        if (secondRef?.current === 0) {
          setShouldCount(false);
          clearInterval(interval);
          setButtonActive(true);
        }
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [shouldCount]);

  const onClickResendOTP = () => {
    onResendOTP(user);
    setSecond(OTP_EXPIRED_TIME);
    setShouldCount(true);
    setButtonActive(false);
  };

  const onSendEvent = async () => {
    return await AmptitudeEvents("User Registration",user?.id, SMS_CODE_ENTERED_EVENT);
  };

  return (
    <SectionContainer className={classes.root} component="section">
      <Box padding="40px 60px 40px 60px">
        <Typography className={classes.titleHeader} align="center">
          Verify your phone number
        </Typography>
        <Box onClick={onSendEvent} className={classes.otpInputContainer}>
          <FruProOTPInput
            className={classes.inputArea}
            value={OTP}
            onChange={(otp) => {
              setOTP(otp);

              if (otp.length === 6) {
                onSubmit(otp);
              }
            }}
            numInputs={6}
          />
        </Box>
        <Typography className={classes.descText} align="left">
          We have sent you 6 - digit code to{" "}
          <span className="fw-bold">{user?.phoneNumber}</span>
        </Typography>
        <Button
          onClick={onClickResendOTP}
          variant="outlined"
          className={
            buttonActive ? classes.resendButton : classes.resenSecondButton
          }
          disabled={!buttonActive}
        >
          Resend
        </Button>
        {second > 0 && (
          <Typography
            className={classes.resenSecondButton}
            align="center"
            style={{ marginTop: "9px", color: "#69CDAE" }}
          >
            <span className={classes.counterResend}>
              <img src="./static/svg/new_time_light.svg" />{" "}
              {`00:${second.toString().padStart(2, "0")}`}
            </span>
          </Typography>
        )}

        {/* <SubmitButton
          disabled={!OTP || OTP?.length < 6 || !second}
          fontSize="24px"
          onClick={() => onSubmit(OTP)}
        >
          Submit
        </SubmitButton> */}
      </Box>
    </SectionContainer>
  );
}
